<template>
  <main id="sample">
    <!-- <Editor
      api-key="7f1lw6kv0eqiwd6jovayp011q1nlgrtlziuzslcpf9bzt7co"
      :init="{
        toolbar_mode: 'sliding',
        plugins: [
          // Core editing features
          'anchor', 'autolink', 'charmap', 'codesample', 'emoticons', 'image', 'link', 'lists', 'media', 'searchreplace', 'table', 'visualblocks', 'wordcount',
          // Your account includes a free trial of TinyMCE premium features
          // Try the most popular premium features until May 16, 2025:
          'checklist', 'mediaembed', 'casechange', 'formatpainter', 'pageembed', 'a11ychecker', 'tinymcespellchecker', 'permanentpen', 'powerpaste', 'advtable', 'advcode', 'editimage', 'advtemplate', 'ai', 'mentions', 'tinycomments', 'tableofcontents', 'footnotes', 'mergetags', 'autocorrect', 'typography', 'inlinecss', 'markdown','importword', 'exportword', 'exportpdf'
        ],
        toolbar: 'undo redo | blocks fontfamily fontsize | bold italic underline strikethrough | link image media table mergetags | addcomment showcomments | spellcheckdialog a11ycheck typography | align lineheight | checklist numlist bullist indent outdent | emoticons charmap | removeformat',
        tinycomments_mode: 'embedded',
        tinycomments_author: 'Author name',
        mergetags_list: [
          { value: 'First.Name', title: 'First Name' },
          { value: 'Email', title: 'Email' },
        ],
        ai_request: (request, respondWith) => respondWith.string(() => Promise.reject('See docs to implement AI Assistant')),
      }"
    /> -->
    <editor
      v-model="content"
      api-key="7f1lw6kv0eqiwd6jovayp011q1nlgrtlziuzslcpf9bzt7co"
      :init="{
        height: 500,
        menubar: false,
        toolbar_mode: 'sliding',
        plugins: ['anchor', 'autolink', 'charmap', 'codesample', 'emoticons', 'image', 'link', 'lists', 'media', 'searchreplace', 'table', 'visualblocks', 'wordcount'],
        toolbar:
          'undo redo | blocks fontsize | bold italic underline strikethrough | link image media table mergetags | spellcheckdialog a11ycheck typography | align lineheight | checklist numlist bullist indent outdent',
        setup(editor) {
          editor.on('paste', (e) => {
            e.preventDefault(); // Block paste
            onPaste();
          });
          editor.on('drop', (e) => {
            e.preventDefault(); // Block drag-drop paste
            onPaste();
          });
          editor.on('init', () => {
          // Add a custom class to the editor wrapper
          const iframeContainer = editor.getContainer();
          iframeContainer.style.border = '1px solid #9ca3af'; // Example: Indigo-600 border
          iframeContainer.style.borderRadius = '8px';
        });
        },
      }"
      class="mt-1 mb-6 border border-gray-900 rounded-md"
      contentType="html"
    />
  </main>
</template>

<script setup>
import Editor from "@tinymce/tinymce-vue";
import Swal from "sweetalert2";

const onPaste = () => {
    Swal.fire({
      icon: "warning",
      title: "Paste is disabled",
      text: "You cannot paste content into this editor.",
    });
};

</script>

<style scoped>
@media (min-width: 1024px) {
  #sample {
    display: flex;
    flex-direction: column;
    place-items: left;
    width: 100%;
  }
}
</style>
